import { render, staticRenderFns } from "./ReceivingReportSkeleton.vue?vue&type=template&id=8df15c3a&"
import script from "./ReceivingReportSkeleton.vue?vue&type=script&lang=js&"
export * from "./ReceivingReportSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports